import { comics } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function Showcase() {
  const spotlight = comics[2]; // 契约·第十二夜

  return (
    <section id="showcase" className="relative py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Spotlight 专题展示"
          title="本周编辑力荐 · 榜单之冠"
          desc="人气与口碑双登顶，编辑部力荐的必追之作，一探它的独特魅力。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* image */}
          <div className="relative">
            <img
              src={spotlight.cover}
              alt={`${spotlight.title} 韩国动态漫画专题海报`}
              className="w-full max-w-md mx-auto h-[360px] md:h-[460px] object-cover object-top rounded-3xl border-4 border-background-50 shadow-sm"
            />
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-black shadow-sm">
              综合评分 {spotlight.rating.toFixed(1)} 分
            </div>
          </div>

          {/* content */}
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-bold">
                <i className="ri-vip-crown-2-fill text-accent-500"></i>
                本周人气 No.1
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-bold">
                <i className="ri-eye-line"></i>
                {spotlight.views} 阅读
              </span>
            </div>

            <h3 className="text-2xl md:text-4xl font-black text-foreground-950 mt-4">{spotlight.title}</h3>
            <p className="text-sm text-foreground-500 mt-2">
              {spotlight.author} 作品 · {spotlight.genre} · 共 {spotlight.episodes} 话 · {spotlight.status}
            </p>

            <div className="flex flex-wrap gap-2 mt-4">
              {spotlight.tags.map((t) => (
                <span key={t} className="px-3 py-1 rounded-full bg-background-50 border border-background-200 text-foreground-700 text-xs font-semibold">
                  #{t}
                </span>
              ))}
            </div>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-5 border-l-4 border-accent-400 pl-4">
              {spotlight.desc}
            </p>

            <ul className="mt-6 space-y-3">
              {[
                "反转不断的梦境规则设定，每集都有新的烧脑惊喜",
                "电影级的分镜与运镜，动态化呈现拉满沉浸感",
                "群像角色塑造立体，情感与推理并行不悖",
              ].map((t) => (
                <li key={t} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-secondary-600 mt-0.5"></i>
                  {t}
                </li>
              ))}
            </ul>

            <a
              href="#contact"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-bookmark-3-line"></i>
              收藏追更
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}